<div class="space-y-3 fixed p-3 w-full sm:w-auto bottom-0 sm:bottom-auto sm:right-0 z-50">
  @for (notification of notifications; track $index) {
    <div [ngClass]="{'bg-green-100/45 ': notification.type === 'success', 'bg-red-200/45': notification.type === 'error', 'bg-amber-200/45': notification.type === 'warning', 'bg-white': notification.type === 'notification', 'bg-hs-red/100 border-hs-red': notification.type === 'blocked'}"
      class="backdrop-blur-lg border border-white-100 bg-opacity-70 animate-fade-up animate-once animate-duration-300 animate-ease-out w-full sm:min-w-[320px] sm:max-w-md rounded-xl mr-2">
      <div class="p-3 rounded-lg flex w-full">
        <div class="p-1 flex items-center mr-3">
          @if (notification.type === 'info') {
            <div>
              <svg class="shrink-0 size-4 text-blue-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16"
                height="16" fill="currentColor" viewBox="0 0 16 16">
                <path
                  d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z">
                </path>
              </svg>
            </div>
          }

          @if (notification.type === 'error') {
            <div>
              <svg class="shrink-0 size-6 text-red-600 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                </svg>
              </div>
            }

            @if (notification.type === 'success') {
              <div>
                <svg class="shrink-0 size-6 text-green-600 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none"
                  viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                  </svg>
                </div>
              }

              @if (notification.type === 'loading') {
                <div>
                  <div class="animate-spin inline-block size-4 border-[3px] border-current border-t-transparent text-blue-600 rounded-full"
                    role="status" aria-label="loading">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              }

              @if (notification.type === 'blocked') {
                <div>
                  <svg class="shrink-0 size-6 text-white mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                    </svg>
                  </div>
                }

              @if (notification.type === 'warning') {
                <div>
                  <svg class="shrink-0 size-6 text-amber-700 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                    </svg>
                  </div>
                }

                @if (notification.type === 'notification') {
                  <div>
                    <svg class="shrink-0 size-5 text-gray-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none"
                      viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
                      </svg>
                    </div>
                  }

                  @if (notification.type === 'credits') {
                    <div>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                          stroke="#0873F7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M18.09 10.37C19.0353 10.7224 19.8765 11.3075 20.5357 12.0712C21.195 12.8349 21.651 13.7524 21.8617 14.7391C22.0724 15.7257 22.0309 16.7495 21.741 17.7158C21.4512 18.6822 20.9223 19.5598 20.2034 20.2676C19.4845 20.9754 18.5987 21.4905 17.6279 21.7652C16.6572 22.04 15.6329 22.0655 14.6496 21.8395C13.6664 21.6134 12.7561 21.1431 12.0028 20.472C11.2495 19.8009 10.6776 18.9507 10.34 18"
                            stroke="#0873F7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M7 6H8V10" stroke="#0873F7" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round" />
                              <path d="M16.71 13.88L17.41 14.59L14.59 17.41" stroke="#0873F7" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                              </svg>
                            </div>
                          }
                        </div>

                        <div (click)="notification?.onAction()"
                          [ngClass]="{'flex-col mt-0.5': notification.message || notification.navigation?.text }"
                          class="grow p-1 flex items-center">
                          <div class="w-full">
                            <h1 class="font-semibold text-sm"
                              [ngClass]="{'text-green-600': notification.type === 'success', 'text-red-600': notification.type === 'error', 'text-amber-700': notification.type === 'warning', 'text-white': notification.type === 'blocked'}">
                              {{ notification.title }}
                            </h1>
                          </div>

                          <div class="w-full pt-1">
                            <p class="text-sm font-normal"
                              [ngClass]="{'text-green-600': notification.type === 'success', 'text-red-600': notification.type === 'error', 'text-amber-700': notification.type === 'warning', 'text-white': notification.type === 'blocked'}">
                              {{ notification.message }}
                            </p>

                            <a [routerLink]="notification.navigation?.url"
                              class="text-sm font-medium text-blue-500 hover:text-blue-700 underline">
                              {{ notification.navigation?.text }}
                            </a>
                          </div>
                        </div>

                        <div class="p-1 flex items-center">
                          <svg (click)="removeNotification(notification)" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor"
                            [ngClass]="notification.type === 'blocked' ? 'text-white/80 hover:text-white' : 'text-gray-400 hover:text-blue-500'"
                            class="size-5 cursor-pointer">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                          </svg>
                        </div>
                      </div>

                      <!-- <div class="p-3 flex items-center space-x-2">
                      <div class="">
                        <div *ngIf="notification.type === 'info'">
                          <svg class="shrink-0 size-4 text-blue-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" width="16"
                            height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path
                              d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z">
                            </path>
                          </svg>
                        </div>

                        <div *ngIf="notification.type === 'error'">
                          <svg class="shrink-0 size-6 text-white mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none"
                            viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round"
                              d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                            </svg>
                          </div>

                          <div *ngIf="notification.type === 'success'">
                            <svg class="shrink-0 size-6 text-green-600 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none"
                              viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round"
                                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                              </svg>
                            </div>

                            <div *ngIf="notification.type === 'loading'">
                              <div class="animate-spin inline-block size-4 border-[3px] border-current border-t-transparent text-blue-600 rounded-full"
                                role="status" aria-label="loading">
                                <span class="sr-only">Loading...</span>
                              </div>
                            </div>

                            <div *ngIf="notification.type === 'notification'">
                              <svg class="shrink-0 size-5 text-gray-500 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
                                </svg>
                              </div>
                            </div>

                            <div class="flex flex-col items-center grow">
                              <div class="w-full">
                                <h1 class="font-semibold text-sm text-green-600">
                                  {{ notification.title }}
                                </h1>
                              </div>

                              <div class="flex">
                                <p class="text-sm text-green-600">
                                  {{ notification.message }}
                                </p>

                                <a [routerLink]="notification.navigation?.url"
                                  class="text-sm font-medium text-blue-500 hover:text-blue-700">
                                  {{ notification.navigation?.text }}
                                </a>
                              </div>
                            </div>

                            <div class="flex-none">
                              <svg (click)="removeNotification(notification)" xmlns="http://www.w3.org/2000/svg" fill="none"
                                viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor"
                                class="size-5 cursor-pointer text-gray-400 hover:text-blue-500">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                              </svg>
                            </div>
                          </div> -->
                        </div>
                      }
                    </div>